import { HttpClient } from '@angular/common/http';
import { EventEmitter, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentList } from '../../classroom360/student-lists/student-list.model';
import { Alerts } from '../student/student.model';
import { System } from '../System';
import { YearService } from '../year/year.service';
import { StudentSearchModel, StudentSearchAllYears } from './student-search-model';
import {StudentSearchCriteria} from './student-search-criteria.model';

@Injectable()
export class StudentSearchService {
    filterCriteria: any[]; // Stores the inputs from the header columns of the grid.
    private _SearchCriteria: StudentSearchCriteria; // Stores the inputs from the top of the student search
    addStudentListEvent = new EventEmitter<StudentList>();
    unsavedStudentFilter = false; // This is used when creating a filter and selecting continue without saving.

    constructor(
        private http: HttpClient,
        private yearService: YearService) {
    }

    get searchCriteria() {
        return this._SearchCriteria;
    }

    set searchCriteria(searchCriteria: StudentSearchCriteria) {
        this._SearchCriteria = searchCriteria;
    }

    getStudentsBySearchCriteria(searchCriteria: StudentSearchCriteria): Observable<any[]> {
        return this.http.post<StudentSearchModel[]>(System.apiURL.Student + 'GetStudentsBySearchCriteria', searchCriteria);
    }

    getStudentsAllYears(firstName: string, lastName: string, studentNumber: string): Observable<any>  {
        return this.http.get<StudentSearchAllYears[]>(System.apiURL.Student + `GetStudentsAllYears?firstName=${firstName}&lastName=${lastName}&studentNumber=${studentNumber}`, {observe : 'response'});
    }

    getAlerts(studentIds: number[], yearId: number, schoolId: number, currentDate) {
        return this.http.post<Alerts[]>(System.apiURL.Student + `GetStudentAlerts?yearId=${yearId}&schoolId=${schoolId}&currentDate=${currentDate}`, studentIds);
    }

    getUserPreferences(studentId, pageURL, subjectListId?, subjectSection?, isDefaultPreferences?): Observable<any[]> {
        return this.http.get<any[]>(System.apiURL.Student + `GetUserPreferences?studentId=${studentId}&pageURL=${pageURL}&subjectListId=${subjectListId}&subjectSection=${subjectSection}&isDefaultPreferences=${isDefaultPreferences}`);
    }

    saveUserPreferences(studentId, pageURL, data, subjectListId?, subjectSection?, isDefaultPreferences?) {
        return this.http.post<any[]>(System.apiURL.Student + `SaveUserPreferences?studentId=${studentId}&pageURL=${pageURL}&subjectListId=${subjectListId}&subjectSection=${subjectSection}&isDefaultPreferences=${isDefaultPreferences}`, data);
    }

    saveFilterCriteria(searchFields) {
        this.filterCriteria = searchFields;
    }

    getSearchCriteria() {
        return this.searchCriteria;
    }

    resetSearchCriteria() {
        this.searchCriteria = new StudentSearchCriteria(
            this.yearService.defaultYear.Id,
            '',
            '',
            '',
            this.yearService.defaultYear.SchoolID.toString(),
            'Active'
        );
    }
}
